import EventBus from '/@/modules/core/app/helpers/EventBus';
import { TableEvent } from '/@/modules/core/table/constants/TableEvent';

export const TableReloadMixin = {
  methods: {
    reloadTable() {
      this.tableId && EventBus.signal(TableEvent.RELOAD, this.tableId);
    },
    reloadAndPersistPage() {
      this.tableId && EventBus.signal(TableEvent.RELOAD_AND_PERSIST_PAGE, this.tableId);
    },
    setLoading(isLoading = true) {
      this.tableId && EventBus.signal(TableEvent.SET_LOADING, this.tableId, isLoading);
    },
    addRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.ADD_ROW, {
          tableId: this.tableId,
          row
        });
    },
    updateRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.UPDATE_ROW, {
          tableId: this.tableId,
          row
        });
    },
    deleteStartRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.DELETE_START_ROW, {
          tableId: this.tableId,
          row
        });
    },
    deleteRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.DELETE_ROW, {
          tableId: this.tableId,
          row
        });
    },
    restoreFailedRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.RESTORE_FAILED_ROW, {
          tableId: this.tableId,
          row
        });
    },
    startIsLoadingRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.START_IS_LOADING_ROW, {
          tableId: this.tableId,
          row
        });
    },
    stopIsLoadingRow(row) {
      this.tableId &&
        EventBus.signal(TableEvent.STOP_IS_LOADING_ROW, {
          tableId: this.tableId,
          row
        });
    }
  }
};
